import React, { useEffect, useState } from 'react'
import { Accordion, Button, Col, Row, Table } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/ContextData';
import DemoModal from '../../components/modals/DemoModal';
import AlertMessage from '../../components/modals/AlertMessage';
import DealerConnectModal from '../../components/modals/DealerConnectModal';
import MoreProducts from '../components/MoreProducts';
import RelatedProducts from '../components/RelatedProducts';
import ImageGallery from 'react-image-gallery';
import { Helmet } from 'react-helmet-async';

const ProductDetails = () => {
    const { demo, dealerId } = useAuth()
    const { pathname } = useLocation();
    const [show, setShow] = useState(false);
    const [active, setActive] = useState();
    const [active2, setActive2] = useState();

    const [page, setPage] = useState(1)
    const [pages, setPages] = useState()
    const [loader, setLoader] = useState(false)
    const [demoToast, setDemoToast] = useState(false);


    const [data, setData] = useState("")
    const [relatedProducts, setRelatedProducts] = useState([]);
    const [moreProducts, setMoreProducts] = useState([]);
    const [banner, setBanner] = useState([])

    useEffect(() => {
        var myHeaders = new Headers();
        myHeaders.append("wu-platform", process.env.REACT_APP_USER_SECRET);
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            "dealerId": dealerId,
            "itemNo": pathname.split('/').pop()
        });
        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        if ((dealerId && dealerId.length === 10)) {
            setBanner([])
            setLoader(true)
            // var requestOptions = {
            //     method: 'POST',
            //     headers: myHeaders,
            //     body: raw,
            //     redirect: 'follow'
            // };

            fetch(process.env.REACT_APP_URL + "customer/item", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "success") {
                        setData(result.data)
                        setRelatedProducts(result.relatedProducts)
                        setMoreProducts(result.moreProducts)
                        setBanner(prevState => [
                            ...prevState,
                            {
                                style_name: "",
                                image: result.data.itemImgDetails.masterimg,
                            },
                            {
                                style_name: "",
                                image: result.data.itemImgDetails.productimg,
                            },
                            {
                                style_name: "",
                                image: result.data.itemImgDetails.closeupimg,
                            },
                        ])
                        result.data.itemImgDetails.stylesImgs.map(obj =>
                            setBanner(prevState => [
                                ...prevState,
                                {
                                    style_name: obj.style_name,
                                    image: obj.demoimg,
                                }
                            ]))

                        setPages(result.pages)
                        setLoader(false)
                    }
                })
                .catch(error => console.log('error', error));
        }
        else if (!dealerId) {

            setBanner([])
            setLoader(true)
            // var myHeaders = new Headers();
            // myHeaders.append("wu-platform", process.env.REACT_APP_USER_SECRET);
            // myHeaders.append("Content-Type", "application/json");

            // var raw = JSON.stringify({
            //     "itemNo": pathname.split('/').pop()
            // });

            // var requestOptions = {
            //     method: 'POST',
            //     headers: myHeaders,
            //     body: raw,
            //     redirect: 'follow'
            // };

            fetch(process.env.REACT_APP_URL + "customer/item", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "success") {
                        setData(result.data)
                        setRelatedProducts(result.relatedProducts)
                        setMoreProducts(result.moreProducts)
                        setBanner(prevState => [
                            ...prevState,
                            {
                                style_name: "",
                                image: result.data.itemImgDetails.masterimg,
                            },
                            {
                                style_name: "",
                                image: result.data.itemImgDetails.productimg,
                            },
                            {
                                style_name: "",
                                image: result.data.itemImgDetails.closeupimg,
                            },
                        ])
                        result.data.itemImgDetails.stylesImgs.map(obj =>
                            setBanner(prevState => [
                                ...prevState,
                                {
                                    style_name: obj.style_name,
                                    image: obj.demoimg,
                                }
                            ]))

                        setPages(result.pages)
                        setLoader(false)
                    }
                })
                .catch(error => console.log('error', error));
        }
    }, [dealerId, pathname])


    const faq = <>
        <h5 className="fw-bold">Frequently Asked Questions (FAQ)</h5>
        {
            data.faqs && data.faqs.map((item, index) => {
                return (
                    <Accordion key={index}>
                        <Accordion.Item className="border-0" eventKey="0">
                            <Accordion.Header className="border-0 text-decoration-none"><div className="fw-bold">{item.question}</div></Accordion.Header>
                            <Accordion.Body className="border-0">
                                {item.answer}
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                );
            })
        }
    </>

    // const videos = <> <h5 className="cpm">Order Overview Video</h5>
    //     <iframe height="250" className="w_83 br_10" src="https://www.youtube.com/embed/7n2T-4W8rbE?controls=0" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
    // </>

    const images = [];
    banner && banner.map(item =>
        images.push({
            original: process.env.REACT_APP_S3URL + item.image,
            thumbnail: process.env.REACT_APP_S3URL + item.image,
        })
    )

    console.log(dealerId);

    return (
        <React.Fragment>
            <DealerConnectModal
                show={show}
                setShow={setShow}
            />
            <DemoModal
                show={demoToast}
                setShow={setDemoToast}
            />


            <div className="wm cp">
                {loader === true ? <div className="App-header">
                    <img src="/assets/icons/wallicon.gif" alt="loader" />
                </div> : <>
                    <Helmet>
                        {/* Page Information */}
                        <title>{data.metaTitle + " " + data.itemNo + " | Wallicon"}</title>
                        {/* <meta name="description"
                            content={productDes.description} />
                        <meta name="keywords" content={productDes.keyword && productDes.keyword.toString() + " " + productDes.itemNo} /> */}

                        {/* Google / Search Engine Tags  */}
                        {/* <meta name="robots" content="max-image-preview:large" />
                        <meta name="robots" content="index, follow" />
                        <link rel="canonical" href="https://wallicon.in" />
                        <meta itemprop="name"
                            content={productDes.title + " " + productDes.itemNo + " | Wallicon"} />
                        <meta itemprop="description" concontent={productDes.description} />
                        <meta itemprop="image" content={masterImg} /> */}

                        {/* Facebook Meta Tags  */}
                        {/* <meta property="og:url" content={window.location.href} />
                        <meta property="og:locale" content="en_IN" />
                        <meta property="og:site_name" content="Wallicon" />
                        <meta property="og:type" content="website" />
                        <meta property="og:title" content={productDes.title + " " + productDes.itemNo + " | Wallicon"} />
                        <meta property="og:description" concontent={productDes.description} />
                        <meta property="og:image" content={masterImg} />
                        <meta property="og:image:secure_url" content={masterImg} />
                        <meta property="og:image:width" content="760" />
                        <meta property="og:image:height" content="407" /> */}

                        {/* Twitter Meta Tags  */}
                        {/* <meta name="twitter:card" content="summary_large_image" />
                        <meta name="twitter:domain" content="wallicon.in" />
                        <meta name="twitter:title" content={productDes.title + " " + productDes.itemNo + " | Wallicon"} />
                        <meta name="twitter:description"
                            concontent={productDes.description} />
                        <meta name="twitter:image" content={masterImg} />
                        <meta name="twitter:image:alt" content={productDes.title + " " + productDes.itemNo + " | Wallicon"} />
                        <meta name="twitter:site" content="@wallicon" />
                        <meta name="twitter:creator" content="@wallicon" /> */}
                    </Helmet>

                    <Row className="mx-0">
                        <Col xl={4} sm={6} className="px-0  mt-4">
                            {/* <Row className="mx-0">
                                <Col xs="2 pe_0 ">
                                    <div className='DescriptionImg overflow-hidden'  style={{height: (getWidth() * images.length)}}>
                                        {images.map((item, index) =>
                                            <div key={index} className="mb-3 ">
                                                {item !== null ?
                                                    <img src={process.env.REACT_APP_URL + item.original}
                                                        alt={productName}
                                                        className={`optionImg mouse ${index === active2 ? 'btnCirlceActive' : ''}`}
                                                        onClick={(e) => {
                                                            setGetImg(e.target.src);
                                                            setActive2(index);
                                                            setActive()
                                                        }}
                                                    />
                                                    : null}
                                            </div>
                                        )}
                                    </div>
                                    <button onClick={() => {nextSlide() }}>Next</button>
                                </Col>
                                <Col className="">
                                    {getImg ?
                                        <img src={getImg} alt={getImg} className="DescriptionImg w-100" />
                                        :
                                        //<div className="w-100">
                                        <img src={productDes.itemImgDetails && process.env.REACT_APP_URL + productDes.itemImgDetails[0].masterimg} alt="5" className="DescriptionImg w-100" />
                                        // </div>
                                    }
                                    <div className="p-2 text-end ">
                                        {productDes.itemColor && productDes.itemColor.split(/,+/).map((item, index) =>
                                            <Button variant="secondary" key={index} className={`rounded-circle border-0 btnCirlce my-1 ms-3 ${index === active ? 'btnCirlceActive' : ''}`} onClick={() => setActive(index)} style={{ background: item }} />
                                        )}
                                    </div>
                                </Col>
                            </Row> */}

                            <ImageGallery
                                items={images}
                                thumbnailPosition="left"
                                // showNav={false}
                                showPlayButton={false}
                            // omMouseHover={showNav}
                            />
                            <div className="p-2 text-end ">
                                {/* {data.itemColor && data.itemColor.split(/,+/).map((item, index) => */}
                                {data.itemColor && data.itemColor.map((item, index) =>
                                    <Button variant="secondary" key={index} className={`rounded-circle border-0 btnCirlce my-1 ms-3 ${index === active ? 'btnCirlceActive' : ''}`} onClick={() => setActive(index)} style={{ background: item }} />
                                )}
                            </div>
                        </Col>

                        <Col xl={5} sm={6} className="mt-4" >
                            <h3 className="pFS_18 fw-bold">{data.title}</h3>
                            <div className="border-top border-1 border-dark  mb-2 mt-4" />

                            <h3 className="fw-bold mt-2 mb-3 pFS_14">Price:
                                {dealerId.toString().length !== 10 ?
                                    <span className="red_clr ms-3 mouse bb2" onClick={() => {
                                        if (demo) {
                                            setDemoToast(true)
                                        } else {
                                            setShow(true)
                                        }
                                    }}
                                    >Check Price
                                    </span> :
                                    <span className="red_clr ms-3">{data.qty > 0 ? <> &#8377; {data.price}/{data.unit} </> : "Out of stock"}</span>
                                }

                            </h3>
                            {data.qty === 20 ? <p className="product_detail_wp mb-0">*hurry,only {data.qty}pcs left!</p> : ''}
                            <div className="border-top border-1 border-dark  mt-2 mb-4" />

                            <h5 className="fw-bold pFS_14">Product Specification:</h5>
                            <Table bordered size="sm" className="muted_clr pFS_12">
                                <tbody>
                                    <tr>
                                        <td>Pattern Number</td>
                                        <td>{data.itemNo}</td>
                                    </tr>
                                    <tr>
                                        <td>Size</td>
                                        <td>{data.itemSize}</td>
                                    </tr>
                                    <tr>
                                        <td>Product Color</td>
                                        <td>{data.itemColor}</td>
                                    </tr>
                                    <tr>
                                        <td>Style</td>
                                        <td>
                                            {banner && banner.map((item, index) => item.style_name === '' || item.style_name === "undefined" ?
                                                null :
                                                <span key={index} className={`${index === active2 ? "text-primary" : ""} mouse`}
                                                    onClick={() => {
                                                        setActive2(index);
                                                        // setGetImg(process.env.REACT_APP_URL + item.demoimg) 
                                                    }}

                                                > {item.style_name}{index === 0 ? "" : ","} </span>)}</td>
                                    </tr>
                                    <tr>
                                        <td>Type</td>
                                        <td>{data.type_name}</td>
                                    </tr>
                                </tbody>
                            </Table>

                            <h5 className="fw-bold pFS_14">Description:</h5>
                            <p className="muted_clr cp pFS_12">
                                {data.description}
                            </p>
                            <div className="d-xl-block d-none">
                                {faq}
                            </div>
                        </Col>

                        <Col className="d-xl-none d-lg-block  tw_center mt-4">
                            <WBP title={data.title} rowCSS="w-50" item={data} />
                        </Col>

                        <Col xl={3} lg={3} className="mt-4 d-xl-block d-none">
                            <WBP title={data.title} item={data} setShow={setShow} />
                            {/* <div className="mt-5">
                                {videos}
                            </div> */}
                        </Col>
                    </Row>
                    <div className="d-xl-none d-lg-block">
                        <Row className="mx-0 mt-5">
                            <Col >
                                {faq}
                            </Col>
                            {/* <Col>
                                {videos}
                            </Col> */}
                        </Row>
                    </div>
                </>}
            </div >


            {loader === true ?
                <div className="moreDataLoader">
                    <img src="/assets/icons/wallicon.gif" alt="loader" />
                </div>
                :
                <RelatedProducts data={relatedProducts} />
            }
            {
                loader === true ?
                    <div className="moreDataLoader">
                        <img src="/assets/icons/wallicon.gif" alt="loader" />
                    </div>
                    :
                    <MoreProducts page={page} pages={pages} setPage={setPage} data={moreProducts} title={'More designs of ' + data.product_name} heading_css='text-center my-5' />
            }

        </React.Fragment >
    )
}

export default ProductDetails


export const WBP = (props) => {
    const navigate = useNavigate();
    const [showToast, setShowToast] = useState(false);
    const [reqType, setReqType] = useState("");
    const [delaerShow, setDelaerShow] = useState(false);
    const [demoToast, setDemoToast] = useState(false);
    const { wished, setWished, removeWished, setRemoveWished, cart, setCart, removeCart, setRemoveCart, demo, dealerId } = useAuth()

    // ---------------------------Wished Items------------------------
    const localWished = JSON.parse(localStorage.getItem("wished"))
    useEffect(() => {
        if (localWished && wished.length === 0) {
            if (removeWished === 0) {
                localStorage.removeItem("wished")
            } else {
                setWished(...wished, localWished)
            }
        }
        if (wished.length !== 0) {
            localStorage.setItem("wished", JSON.stringify(wished))
        }

    }, [wished, setWished, localWished, removeWished,])

    // ---------------------------Cart Items------------------------
    const localCart = JSON.parse(localStorage.getItem("cart"))
    useEffect(() => {
        if (localCart && cart.length === 0) {
            if (removeCart === 0) {
                localStorage.removeItem("cart")
            } else {
                setCart(...cart, localCart)
            }
        }
        if (cart.length !== 0) {
            localStorage.setItem("cart", JSON.stringify(cart))
        }

    }, [cart, setCart, localCart, removeCart,])

    let title = props.title
    const [copy, setCopy] = useState();
    // const [copySuccess, setCopySuccess] = useState('');

    const copyCodeToClipboard = () => {
        const el = copy
        el.select()
        document.execCommand("copy")
        // setCopySuccess('Link copied successfully!')
        alert('Link copied successfully!')
    }

    return (
        <React.Fragment>
            <AlertMessage
                show={showToast}
                setShow={() => setShowToast(false)}
                reqType={reqType}
            />
            <DealerConnectModal
                show={delaerShow}
                setShow={setDelaerShow}
            />
            <DemoModal
                show={demoToast}
                setShow={setDemoToast}
            />

            <Row className={`${props.rowCSS} mx-0`}>
                <Col className=" border p-2 br_10 text-center">
                    <h5 className="mt-2 cpm pFS_16">
                        Free Installation Eligible <img src="/assets/icons/tick_mark.png" alt="tick_mark" className="ms-1 mb-1" height="15" />
                    </h5>

                    <h5 className="text-danger mt-3">
                        <img src={wished.find(obj => obj.itemNo === props.item.itemNo) ? "/assets/icons/wished.png" : "/assets/icons/wish.svg"} alt="heart" className="me-2" height="20" />
                        <button className="text-decoration-underline text-dark pFS_16 cpm mouse border-0 bg-transparent" disabled={!props.item.price || props.item.qty < 1}
                            onClick={() => {
                                if (demo) {
                                    setDemoToast(true)
                                }
                                else if (!dealerId) {
                                    setDelaerShow(true)
                                }
                                else if (wished.find(obj => obj.itemNo === props.item.itemNo)) {
                                    if (wished.length === 1) {
                                        setRemoveWished(0)
                                        setReqType("removeWished")
                                    }
                                    const x = wished.indexOf(wished.find(obj => obj.itemNo === props.item.itemNo))
                                    wished.splice(x, 1)
                                    setWished([...wished])
                                    setReqType("removeWished")
                                }
                                else if (cart.find(obj => obj.itemNo === props.item.itemNo)) {
                                    if (cart.length === 1) {
                                        setRemoveCart(0)
                                        setWished([...wished, {
                                            cartType: props.item.cartType,
                                            itemNo: props.item.itemNo,
                                            masterimg: props.item.itemImgDetails.masterimg,
                                            metaTitle: props.item.metaTitle,
                                            price: props.item.price,
                                            product_name: props.item.product_name,
                                            collection_name: props.item.collection_name,
                                            qty: props.item.qty,
                                            title: props.item.title,
                                            unit: props.item.unit,
                                        }])
                                        setReqType("moveWished")
                                        setShowToast(true)
                                    }
                                    const x = cart.indexOf(cart.find(obj => obj.itemNo === props.item.itemNo))
                                    cart.splice(x, 1)
                                    setCart([...cart])
                                    setWished([...wished, {
                                        cartType: props.item.cartType,
                                        itemNo: props.item.itemNo,
                                        masterimg: props.item.itemImgDetails.masterimg,
                                        metaTitle: props.item.metaTitle,
                                        price: props.item.price,
                                        product_name: props.item.product_name,
                                        collection_name: props.item.collection_name,
                                        qty: props.item.qty,
                                        title: props.item.title,
                                        unit: props.item.unit,
                                    }])
                                    setReqType("moveWished")
                                    setShowToast(true)
                                }
                                else {
                                    setWished([...wished, {
                                        cartType: props.item.cartType,
                                        itemNo: props.item.itemNo,
                                        masterimg: props.item.itemImgDetails.masterimg,
                                        metaTitle: props.item.metaTitle,
                                        price: props.item.price,
                                        product_name: props.item.product_name,
                                        collection_name: props.item.collection_name,
                                        qty: props.item.qty,
                                        title: props.item.title,
                                        unit: props.item.unit,
                                    }])
                                    setReqType("addWished")
                                    setShowToast(true)
                                }
                            }}
                        >
                            {
                                wished.find(obj => obj.itemNo === props.item.itemNo) ?
                                    "Remove From Wishlist" : "Add To Wishlist"
                            }
                        </button>
                    </h5>
                    <div>
                        <button disabled={!props.item.price || props.item.qty < 1} className="bg-white outline-none border_clr text-dark rounded px-5 py-1 mt-4 pFS_16 cp"
                            onClick={() => {
                                if (demo) {
                                    setDemoToast(true)
                                } else if (!dealerId) {
                                    setDelaerShow(true)
                                }
                                else if (cart.find(obj => obj.itemNo === props.item.itemNo)) {
                                    navigate("/checkout/cart")
                                }
                                else if (wished.find(obj => obj.itemNo === props.item.itemNo)) {
                                    if (wished.length === 1) {
                                        setRemoveWished(0)
                                        setCart([...cart, {
                                            cartType: props.item.cartType,
                                            itemNo: props.item.itemNo,
                                            masterimg: props.item.itemImgDetails.masterimg,
                                            metaTitle: props.item.metaTitle,
                                            price: props.item.price,
                                            product_name: props.item.product_name,
                                            collection_name: props.item.collection_name,
                                            qty: props.item.qty,
                                            title: props.item.title,
                                            unit: props.item.unit,
                                        }])
                                        setReqType("moveCart")
                                        setShowToast(true)
                                    }
                                    const x = wished.indexOf(wished.find(obj => obj.itemNo === props.item.itemNo))
                                    wished.splice(x, 1)
                                    setWished([...wished])
                                    setCart([...cart, {
                                        cartType: props.item.cartType,
                                        itemNo: props.item.itemNo,
                                        masterimg: props.item.itemImgDetails.masterimg,
                                        metaTitle: props.item.metaTitle,
                                        price: props.item.price,
                                        product_name: props.item.product_name,
                                        collection_name: props.item.collection_name,
                                        qty: props.item.qty,
                                        title: props.item.title,
                                        unit: props.item.unit,
                                    }])
                                    setReqType("moveCart")
                                    setShowToast(true)
                                }
                                else {
                                    setCart([...cart, {
                                        cartType: props.item.cartType,
                                        itemNo: props.item.itemNo,
                                        masterimg: props.item.itemImgDetails.masterimg,
                                        metaTitle: props.item.metaTitle,
                                        price: props.item.price,
                                        product_name: props.item.product_name,
                                        collection_name: props.item.collection_name,
                                        qty: props.item.qty,
                                        title: props.item.title,
                                        unit: props.item.unit,
                                    }])
                                    setReqType("addCart")
                                    setShowToast(true)
                                }
                            }}
                        >
                            {
                                cart.find(obj => obj.itemNo === props.item.itemNo) ?
                                    "Go To Cart" : "Add To Cart"
                            }
                        </button>
                    </div>
                    <div>
                        {/* <Button className="border-0 bg_green_clr br_10 text-dark fw-bold py-3 my-5 font-monospace fs-5" onClick={()=> {dealerID.length === 0  ? handleShow() : history.push('/checkout/cart') }}>Proceed To Order</Button> */}
                        <button disabled={props.item.qty < 1}
                            className="bg_green_clr outline-none border-0 rounded px-4 py-1 mt-4 mb-3 pFS_16 cp"
                            onClick={() => {
                                if (demo) {
                                    setDemoToast(true)
                                } else if (!dealerId) {
                                    props.setShow(true)
                                } else if (cart.find(obj => obj.itemNo === props.item.itemNo)) {
                                    navigate('/checkout/cart');
                                } else {
                                    setCart([...cart, {
                                        cartType: props.item.cartType,
                                        itemNo: props.item.itemNo,
                                        masterimg: props.item.itemImgDetails.masterimg,
                                        metaTitle: props.item.metaTitle,
                                        price: props.item.price,
                                        product_name: props.item.product_name,
                                        collection_name: props.item.collection_name,
                                        qty: props.item.qty,
                                        title: props.item.title,
                                        unit: props.item.unit,
                                    }])
                                    navigate('/checkout/cart');
                                }
                            }}
                        >
                            Proceed To Order
                        </button>
                    </div>
                </Col>
                <Col xs="2" className="ps-3 mt-2 ">
                    <img src="/assets/icons/share1.png" alt="whatsapp" className="icon-circle-red mb-2" />
                    <br />
                    <label className="mouse" onClick={() => { copyCodeToClipboard(); }} htmlFor="copy">
                        <img src="/assets/icons/copy.png" alt="whatsapp" className="icon-circle-red my-2" />
                    </label>
                    <br />
                    <a target="blank" href={"https://wa.me/?text=" + title + " " + window.location.href} >
                        <img src="/assets/icons/WA.png" alt="whatsapp" className="icon-circle-red my-2" />
                    </a>
                    <br />
                    <a target="blank" href={"https://facebook.com/sharer.php?u=" + window.location.href} >
                        <img src="/assets/icons/fbO.png" alt="fb" className="icon-circle-red my-2" />
                    </a>
                    <br />
                    <a target="blank" href={"https://twitter.com/intent/tweet?url=" + title + " " + window.location.href} >
                        <img src="/assets/icons/twit.png" alt="twitter" className="icon-circle-red my-2" />
                    </a>

                </Col>
            </Row>
            <div className='position-absolute bottom-0'>
                <input type="text"
                    ref={(el) => setCopy(el)}
                    defaultValue={window.location.href}
                    // className="w-75 mt-4 mb-2 d-none"
                    className="opacity-0"
                    id="copy"
                />
            </div>
        </React.Fragment>
    )
}
